import React, { useState } from "react";
import { auth } from "./common/firebase";
import { signOut } from "firebase/auth";
import { useAuth } from "./common/Auth";

import defaultIcon from "./simulcasticon.svg";

export default function TopNav({history, icon: appIcon, homeClicked}) {
  const currentUser = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const doSignOut = (e) => {
	  e.preventDefault();
	  setMenuOpen(false);
	  signOut(auth);
  }

  const goHome = (e) => {
	e.preventDefault();
	if (homeClicked) homeClicked();
  }

  return (
    <div>
	  <div className="w-full bg-[#880e4f] text-white px-3 sm:px-5 py-2 sm:py-2.5 flex items-center gap-2 sm:gap-4 border-b border-[#6b0b3f]">
	    <div className="flex items-center gap-2 sm:gap-2.5 min-w-0">
	      <img 
	        src={appIcon || defaultIcon} 
	        alt="logo" 
	        className="h-7 sm:h-8 w-auto max-w-[36px] sm:max-w-[40px] shrink-0" 
	        style={{ height: '28px', width: 'auto', maxWidth: '36px' }} 
	      />
	      <span className="font-semibold tracking-tight text-sm sm:text-base truncate">Simulcast</span>
	    </div>
	    <div className="hidden sm:block flex-1 text-xs opacity-75 font-mono truncate">{currentUser && currentUser.email}</div>
	    <div className="flex items-center gap-1 ml-auto shrink-0">
	      <button 
	        onClick={goHome} 
	        className="px-2 sm:px-3 py-1 text-xs rounded-md hover:bg-white/15 transition-colors flex items-center gap-1.5"
	      >
	        Home
	      </button>
	      <div className="relative hidden sm:block">
	        <button 
	          onClick={() => setMenuOpen(!menuOpen)} 
	          className="px-3 py-1 text-xs rounded-md hover:bg-white/15 transition-colors"
	        >
	          Account
	        </button>
	        {menuOpen && (
	          <div className="absolute right-0 mt-2 bg-white dark:bg-gray-900 text-black dark:text-white shadow-xl rounded-xl text-sm py-1 min-w-[150px] z-50 border border-gray-200 dark:border-gray-700 overflow-hidden">
	            <div onClick={() => setMenuOpen(false)} className="px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-800 cursor-pointer text-sm">Profile</div>
	            <div onClick={doSignOut} className="px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-800 cursor-pointer text-sm text-red-600">Sign Out</div>
	          </div>
	        )}
	      </div>
	    </div>
	  </div>
	</div>
  );
}